import React from 'react'
import './price.scss'
import '../../styles/index.scss'
import { priceProduct } from '../../data/data-intro'
import img from '../../assets/images/price/brush.png'
import box0 from '../../assets/images/price/box1.png'
import box1 from '../../assets/images/price/box2.png'
import img1 from '../../assets/images/footer/bg.png'

const PricePage = () => {
    return (
        <>
            <div className='priceNP hidden'>
                <div className="container">
                    <div className='priceNP-title'>
                        Giá sản phẩm
                    </div>
                    <div className='priceNP-content'>
                        <div className='priceNP-content-item' >
                            <div className='priceNP-content-item-box'>
                                <img loading="lazy" src={box0} alt="image" />
                            </div>
                            <h5> {priceProduct[0]?.title}</h5>
                            <div className='priceNP-content-item-price'>
                                <img loading="lazy" src={img1} alt="image" />
                                <p>
                                    {priceProduct[0]?.price}
                                </p>
                            </div>
                        </div>
                        <div className='priceNP-content-item' >
                            <div className='priceNP-content-item-box' style={{ width: 350 }}>
                                <img loading="lazy" src={box1} alt="image" />
                            </div>
                            <h5 style={{ paddingTop: 100 }}> {priceProduct[1]?.title}</h5>
                            <div className='priceNP-content-item-price'>
                                <img loading="lazy" src={img1} alt="image" />
                                <p>
                                    {priceProduct[1]?.price}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className='priceNP-text-bottom'>
                        <p>*Giá trên đã bao gồm VAT (10%)</p>
                        <p> Vui lòng liên hệ Đại lý gần nhất để nhận giá và chiết khấu cụ thể.

                        </p>
                    </div>
                </div>

            </div>
        </>
    )

}

export default PricePage
